import React from 'react';
import Container from '@/components/Container';
import Typography from '@mui/material/Typography';
import TextInput from '@/components/forms/TextInput';

interface KulturNavProps {
  blockPath: string;
  tComponents: (key: string) => string;
}

const FilterKulturNav: React.FC<KulturNavProps> = ({ blockPath, tComponents }) => (
  <Container fullWidth column>
    <Container fullWidth left>
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
        {tComponents('DMFilterSearch.KulturNavTitleLabel')}
      </Typography>
    </Container>
    <TextInput path={`${blockPath}.kulturnavuuid`} label='UUID' />
  </Container>
);

export default FilterKulturNav;
